
import type { PropType } from 'vue'
import type { TimeSlot } from '@/new-services/types/time-slots'

import { defineComponent, reactive } from 'vue'

import TimeSlotItemResources from './TimeSlotItemResources.vue'
import TimeSlotItemSectors from './TimeSlotItemSectors.vue'
import TimeSlotItemChild from './TimeSlotItemChild.vue'

export default defineComponent({
    components: {
        TimeSlotItemResources,
        TimeSlotItemSectors,
        TimeSlotItemChild
    },
    props: {
        item: {
            type: Object as PropType<TimeSlot>,
            required: true,
        }
    },
    emits: ['change-status'],
    setup(props, { emit }) {
        const state = reactive({
            is_opened: false,
        })

        const toggle = () => state.is_opened = !state.is_opened
        const format = (timeStr: string) => timeStr.substring(0, 5)

        const onChangeStatus = () => emit('change-status', { timeSlotId: props.item.id, statusId: props.item.status.id })
        const onChangeStatusInChild = (payload: { timeSlotId: number; statusId: number; }) => emit('change-status', payload)

        return {
            state,
            toggle,
            format,
            onChangeStatus,
            onChangeStatusInChild
        }
    }
})
